import { VehicleOption } from './vehicle';

export enum VehicleSorterTypes {
  Price = 'PRICE',
  Recommended = 'RECOMENDATION',
  PriceDesc = 'PRICE_HIGH',
}
export interface VehicleResultsFilters {
  company?: string[];
  transmissionType?: string[];
  maxPax?: number[];
  doors?: number[];
  model?: string[];
  fuelType?: string[];
  airConditioned?: boolean[];
  vehicleCategory?: string[];
  priceTo?: number;
  priceFrom?: number;
  priceRanges?: number[];
  provider?: string[];
  orderCriteria?: VehicleSorterTypes;
  orderDesc?: boolean;
  tags?: string[];
  travelPolicies?: string[];
}

export interface VehicleResultsPayload {
  distanceRestriction?: string;
  searchId?: string;
  company?: string[];
  transmissionType?: string[];
  maxPax?: number[];
  doors?: number[];
  model?: string[];
  fuelType?: string[];
  airConditioned?: boolean[];
  vehicleCategory?: string[];
  priceTo?: number;
  priceFrom?: number;
  provider?: string[];
  resultCountLowerBound?: number;
  resultCountUpperBound?: number;
  orderCriteria?: VehicleSorterTypes;
  orderDesc?: boolean;
  resultsCount?: number;
  tags?: string[];
  sessionToken?: string;
  userId?: string;
  travelArrangerUserId?: string;
}

export type VehicleResultsResponse = {
  vehicleOptions?: VehicleOption[];
  searchId?: string;
  resultsCount?: number;
};
